import styles from './Privacypolicy.module.css';
const Privacypolicy = () => {
  return (
    <div className={styles.container}>
        <h1 className={styles.mainheader}>iCredentialing Privacy Policy</h1>
        <p className={styles.content}><em>Last updated: May 30, 2025</em></p>
        <p className={styles.content}>
                Innovative Health Systems, Inc. doing business as <strong>iCredentialing</strong> ("iCredentialing," "we," "us,"
            or "our") respects your privacy and is committed to protecting the information you entrust to us.
            This Privacy Policy explains how we collect, use, disclose, and safeguard information when you
            visit <strong>icredentialing.com</strong> (including any sub-pages, the "Site") or use any of our cloud-based
            credentialing, payer-enrollment, monitoring, or related services (collectively, the "Services").
        </p>
         <p className={styles.content}>
                By accessing the Site or using the Services, you acknowledge that you have read and understood
            this Privacy Policy and agree to our information-handling practices.<strong> If you do not agree, please
            do not use the Site or the Services.</strong> Your use of the Services is also governed by our [Website
            Terms of Use].
        </p>
            <h2 className={styles.subheader}>1. Information We Collect</h2>
                <h3 className={styles.subheader}>1.1 Information You Provide to Us</h3>
                <p className={styles.content}>
                    Depending on how you interact with iCredentialing, you may provide:
                </p>   
                <ul className={styles.listelements}>
                    <li key='1'>
                        <strong>Contact details</strong> – full name, mailing address, email address, telephone number.
                    </li>
                    <li key='2'>
                        <strong>Account credentials</strong> – user ID, password, security questions.
                    </li>
                    <li key='3'>
                        <strong>Professional data</strong> – license numbers, National Provider Identifier (NPI), clinical
                        privileges, résumé/CV, education history, certifications, references, vaccination or
                        immunization records, other documentation required for credentialing or enrollment.
                    </li>
                    <li key='4'>
                        <strong>Payment information</strong> – credit/debit-card number, bank account details, billing address.
                    </li>
                    <li key='5'>
                        <strong>Communications</strong> – support tickets, survey responses, or other messages you send us.
                    </li>
                </ul>
            <h3 className={styles.subheader}>1.2 Information We Receive from Third Parties
            We may obtain additional information from:</h3>
             <ul className={styles.listelements}>
                    <li key='1'>
                        <strong>Healthcare organizations and payers</strong> ("Network Partners") that subscribe to our
                        platform.
                    </li>
                    <li key='2'>
                        <strong>Background-screening and verification vendors</strong> engaged to confirm qualifications or
                        perform sanctions checks.
                    </li>
                    <li key='3'>
                        <strong>Public sources</strong> such as licensure boards or government registries.
                    </li>
                </ul>
            <h3 className={styles.subheader}>1.3 Information Collected Automatically</h3>
            <p className={styles.content}>
                When you visit the Site, we automatically log certain non-personal information, including IP
                address, browser type, device identifiers, pages viewed, links clicked, and timestamps. We
                collect this data through cookies, web beacons, pixel tags, and similar technologies. See 
                <strong> Section 6</strong> for details.
            </p>
            <h2 className={styles.subheader}>2. How We Use Information</h2>
            <p className={styles.content}>
                We use personal and non-personal information to:
            </p>
             <ol className={styles.listelements}>
                    <li key='1'>
                        <strong>Provide and secure the Services</strong> – authentication, credentialing workflows,
                        payer-enrollment transactions, and technical support.
                    </li>
                    <li key='2'>
                        <strong>Facilitate interactions with Network Partners</strong> – enabling authorized facilities and
                        payers to locate, verify, and communicate with credentialed professionals.
                    </li>
                    <li key='3'>
                        <strong>Process payments and manage subscriptions.</strong>
                    </li>
                    <li key='4'>
                        <strong>Send administrative messages</strong> – confirmations, invoices, reminders, security alerts,
                        policy updates, and legally required notices.
                    </li>
                    <li key='5'>
                        <strong>Improve and develop our products</strong> – performing analytics, conducting research,
                        enhancing user experience.
                    </li>
                    <li key='6'>
                        <strong>Market our offerings</strong> – sending promotional communications about new features or
                        industry insights (you may opt out at any time).
                    </li>
                    <li key='7'>
                        <strong>Comply with legal obligations</strong> – responding to lawful requests, enforcing our Terms of
                        Use, maintaining regulatory records.
                    </li>
                    <li key='8'>
                        <strong>Protect rights and safety</strong> – detecting, investigating, and preventing fraud, misuse, or
                        security incidents.
                    </li>
                </ol>
            <p className={styles.content}>
                We may aggregate or de-identify data so it no longer reasonably identifies you; we may use or
                disclose such data for any lawful purpose.
            </p>
            <h2 className={styles.subheader}>3. Legal Bases for Processing (EEA/UK Users)</h2>
            <p className={styles.content}>            
                If you are located in the European Economic Area or the United Kingdom, we process your
                personal data when we have a valid legal basis: (a) performance of a contract, (b) legitimate
                interests (e.g., securing the Services), (c) your consent, or (d) compliance with a legal obligation.
            </p>
            <h2 className={styles.subheader}>4. How We Share Information</h2>
            <table className={styles.tabl}>
                <tbody>
                    <tr className={styles.header}>
                    <th className={`${styles.cell} ${styles.firstCol}`}><strong>Recipient</strong></th>
                    <th className={`${styles.cell} ${styles.secondCol} ${styles.secondhead}`}><strong>Purpose</strong></th>
                    </tr>
                    <tr className={styles.row}>
                    <td className={`${styles.cell} ${styles.firstCol}`}><strong>Network Partners</strong></td>
                    <td className={`${styles.cell} ${styles.secondCol}`}>Credentialing, enrollment, privileging, and monitoring of providers.</td>
                    </tr>
                    <tr className={styles.row}>
                    <td className={`${styles.cell} ${styles.firstCol}`}><strong>Service Providers</strong></td>
                    <td className={`${styles.cell} ${styles.secondCol}`}>
                        Cloud hosting (AWS), data-center operations, background checks, payment processing, email delivery, analytics, customer-support tools - all bound by contract to protect information.
                    </td>
                    </tr>
                    <tr className={styles.row}>
                    <td className={`${styles.cell} ${styles.firstCol}`}><strong>Professional Advisers</strong></td>
                    <td className={`${styles.cell} ${styles.secondCol}`}>Auditors, accountants, and lawyers under confidentiality obligations.</td>
                    </tr>
                    <tr className={styles.row}>
                    <td className={`${styles.cell} ${styles.firstCol}`}><strong>Authorities & Legal Parties</strong></td>
                    <td className={`${styles.cell} ${styles.secondCol}`}>When required by law or to protect our rights, privacy, safety, or property, or that of users or others.</td>
                    </tr>
                    <tr className={styles.row}>
                    <td className={`${styles.cell} ${styles.firstCol}`}><strong>Business Transferees</strong></td>
                    <td className={`${styles.cell} ${styles.secondCol}`}>In connection with a merger, acquisition, sale of assets, or similar transaction.</td>
                    </tr>
                </tbody>
            </table>

            <p className={styles.content}>
                We do <strong>not</strong> sell personal information for monetary consideration, and we <strong>do not offshore data
                processing to third parties without strict security and legal agreements</strong>.
            </p>
            <h2 className={styles.subheader}>5. Data Retention and Disposal</h2>
            <p className={styles.content}>             
                We retain personal information for as long as necessary to fulfill the purposes outlined in this
                Policy, comply with legal and contractual requirements, resolve disputes, and enforce
                agreements. When data is no longer needed, we securely dispose of electronic media (e.g.,
                cryptographic wiping) and paper records (e.g., shredding) in accordance with HIPAA Security
                Rule §164.310(d) and NIST SP 800-88 guidelines.
            </p>
            <h2 className={styles.subheader}>6. Cookies & Similar Technologies</h2>
            <p className={styles.content}>            
                Cookies are small text files stored on your device that help us remember your preferences and
                improve site performance. You can manage cookies in your browser settings, but disabling them
                may impair certain features of the Site. We also use web beacons and local storage to gather
                usage analytics and measure communication effectiveness.
            </p>
            <h2 className={styles.subheader}>7. Security</h2>
            <h3 className={styles.subheader}>7.1 Protection of Personal Information</h3>
            <p className={styles.content}>            
                We employ administrative, technical, and physical safeguards – including TLS encryption,
                firewalls, intrusion detection, and data-at-rest encryption – to protect information against loss,
                theft, misuse, and unauthorized access or disclosure. Access is role-based and follows the
                principle of least privilege.
            </p>
            <h3 className={styles.subheader}>7.2 Access Controls & Audit Logging</h3>
            <p className={styles.content}>            
                Unique user IDs, strong passwords, and multi-factor authentication are required for system
                access. System activity is logged and regularly reviewed to detect and respond to unauthorized
                behavior, in compliance with HIPAA Security Rule §164.312.
            </p>
            <h3 className={styles.subheader}>7.3 Employee Training & Confidentiality</h3>
            <p className={styles.content}>            
                All workforce members sign confidentiality agreements and complete initial and annual HIPAA
                privacy and security training in accordance with 45 CFR §164.530(b). Training also addresses
                NCQA CVO, URAC CVO, and TJC confidentiality standards.
            </p>
            <h3 className={styles.subheader}>7.4 Incident & Breach Response</h3>
            <p className={styles.content}>            
                We maintain an incident response plan. Suspected security events are investigated promptly. For
                a breach of unsecured PHI, we notify the covered entity without unreasonable delay and no later
                than 60 days after discovery, satisfying 45 CFR §164.410 and HITECH §13402.
            </p>
            <h2 className={styles.subheader}>7A. HIPAA and Protected Health Information</h2>
            <p className={styles.content}>             
                Certain Network Partners qualify as “covered entities” under the Health Insurance Portability
                and Accountability Act of 1996 ("HIPAA"). When iCredentialing receives, creates, transmits, or
                maintains protected health information ("PHI") on behalf of those partners, we act as a <strong>Business
                Associate</strong> under the HIPAA Privacy, Security, and Breach Notification Rules, as amended by the
                HITECH Act.
            </p>
            <p className={styles.content}>            
                We enter into Business Associate Agreements (BAAs) with our clients and implement the
                required safeguards to ensure the confidentiality, integrity, and availability of PHI as mandated
                by 45 CFR §164.308, §164.310, and §164.312. Key measures include:
            </p>
             <ul className={styles.listelements}>
                    <li key='1'>
                        Role-based access control (least privilege)
                    </li>
                    <li key='2'>
                        Unique user identification and password protection
                    </li>
                    <li key='3'>
                        Audit logging and access monitoring
                    </li>
                    <li key='4'>
                        Secure disposal of electronic and paper PHI
                    </li>
                    <li key='5'>
                        TLS encryption of data in transit and AES-256 encryption at rest
                    </li>
                    <li key='6'>
                        Alignment with NIST SP 800-111 and NIST SP 800-88 for storage and destruction
                    </li>
                </ul>
            <p className={styles.content}>
                We do not use or disclose PHI except as permitted by the BAA or required by law.
            </p>
            <h2 className={styles.subheader}>8. Alignment with NCQA, URAC, TJC, and CMS Standards</h2>
            <h3 className={styles.subheader}>NCQA (National Committee for Quality Assurance)</h3>
            <p className={styles.content}>            
                We protect credentialing information in line with NCQA Credential Verification Organization
                (CVO) standards, restricting file access to authorized personnel and ensuring secure storage and
                transmission.
            </p>
            <h3 className={styles.subheader}>URAC (Utilization Review Accreditation Commission)</h3>
            <p className={styles.content}>        
                Consistent with URAC CVO Core standards 15–17, 27:
            </p>
             <ul className={styles.listelements}>
                    <li key='1'>
                        We maintain confidentiality of individually identifiable health and credentialing data.
                    </li>
                    <li key='2'>
                        We provide regular workforce training on data protection.
                    </li>
                    <li key='3'>
                        We maintain business continuity and incident response plans.
                    </li>
                    <li key='4'>
                        We review marketing materials for compliance (CVO Core 10).
                    </li>
                </ul>
            <h3 className={styles.subheader}>The Joint Commission (TJC)</h3>
            <p className={styles.content}>        
                Per standard IM.01.01.01, we protect confidential provider information and support accurate,
                secure data collection and storage for TJC-participating organizations.
            </p>
            <h3 className={styles.subheader}>CMS (Centers for Medicare & Medicaid Services)</h3>
            <p className={styles.content}>            
                When processing data for CMS enrollment or related programs, we comply with CMS privacy
                and data-security rules to safeguard provider information.
            </p>
            <h2 className={styles.subheader}>9. Your Rights & Choices</h2>
            <p className={styles.content}>
                Depending on your jurisdiction, you may have rights to:
            </p>
             <ul className={styles.listelements}>
                    <li key='1'>
                        <strong>Access</strong> the personal information we hold about you.
                    </li>
                    <li key='2'>
                        <strong>Correct</strong> inaccurate or incomplete data.
                    </li>
                    <li key='3'>
                        <strong>Delete</strong> or <strong>restrict</strong> the processing of your information.
                    </li>
                    <li key='4'>
                        <strong>Object</strong> to certain processing, including direct marketing.
                    </li>
                    <li key='5'>
                        <strong>Receive</strong> a portable copy of your data.
                    </li>
                    <li key='6'>
                        <strong>Opt-out</strong> of the sale or sharing of personal information (where applicable).
                    </li>
                </ul>
             <p className={styles.content}> 
                To exercise these rights, email <strong>privacy@icredentialing.com</strong> or log in to your account. If you
                request PHI access or amendment, we will coordinate with the covered entity to address your
                request.
            </p>
            <h2 className={styles.subheader}>10. Children’s Privacy</h2>
            <p className={styles.content}>            
                The Services are intended for professionals aged 18 and over. We do not knowingly collect
                personal information from children under 13. If we learn we have inadvertently received such
                information, we will delete it.
            </p>
            <h2 className={styles.subheader}>11. International Data Transfers</h2>
            <p className={styles.content}>         
                iCredentialing is headquartered in the United States, and our Services are primarily operated
                from within the U.S. We store and process most customer data on U.S. servers.
            </p>
            <p className={styles.content}>
                In limited cases—such as supporting international users or working with global service
                providers—your information may be accessed or processed in other jurisdictions. When this
                occurs, we implement appropriate safeguards (e.g., Standard Contractual Clauses or equivalent
                mechanisms) to ensure your data remains protected.                     
            </p>
            <p className={styles.content}>       
                By using the Services, you understand that your information may be transferred to and processed
                in the United States and, when necessary, other countries in accordance with this Privacy Policy.
            </p>
            <h2 className={styles.subheader}>12. Changes to This Privacy Policy</h2>
            <p className={styles.content}>
                We may update this Policy periodically. The "Last updated" date at the top indicates when
                revisions took effect. Material changes will be announced via the Site or other appropriate
                channels. Continued use of the Services after an update signifies your acceptance of the revised
                Policy.
            </p>
            <h2 className={styles.subheader}>13. Contact Us</h2>
            <p className={styles.content}>
                For questions, concerns, or requests regarding this Privacy Policy, contact:
            </p>
            <p>
                <strong>Innovative Health Systems, Inc. dba iCredentialing</strong>
            </p>
            <p>
                   Attn:Privacy Office
            </p>
            <p>
                2372 Morse Ave, Suite 1020
            </p>
            <p>
                Irvine, CA 92614 USA
            </p>
            <p>
                Phone: (949) 390-2661
            </p>
            <p>
                Email: <strong>privacy@icredentialing.com</strong>
            </p>    
            <p className={styles.content}>
                You may also reach out to your local data-protection authority if you believe we have not
                adequately addressed your privacy concerns.
            </p>
            <h3 className={styles.subheader}>Opt-Out of Marketing</h3>
            <p className={styles.content}>
                You may unsubscribe from promotional emails at any time by clicking the "unsubscribe" link in
                the message or by emailing <strong>privacy@icredentialing.com </strong>with the subject line "Opt-Out." Even
                if you opt out of marketing, we may send you transactional or service-related communications.
            </p>
    </div>
  )
}

export default Privacypolicy
